import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { LEARNINGS, NEXT_ACTION } from '../../data/insights';

/** Two example insights and the one action they point to. */
export function InsightNotes() {
  return <div className="flex flex-col gap-4 lg:col-span-5" data-id="element-68" data-mp="2mvfxx4ntozml">
      <section aria-labelledby="learn-title" className="flex-1 rounded-2xl bg-white p-5" data-id="element-69" data-mp="2rvkbomxcjg94">
        <h3 id="learn-title" className="text-[13px] font-semibold text-ink" data-id="element-70" data-mp="2rt7n3qx327n3">
          What did we learn?
        </h3>
        <ul className="mt-4 divide-y divide-hair" data-id="element-71" data-mp="2iuma0badrktp">
          {LEARNINGS.map(l => <li key={l.title} className="py-3 first:pt-0 last:pb-0" data-id="element-72" data-mp="23xmttz1gqjnm">
              <p className="flex items-baseline gap-2" data-id="element-73" data-mp="23zfyx9wfgvti">
                <span className="tabular font-serif text-[30px] leading-none tracking-[-0.02em] text-teal" data-id="element-74" data-mp="28vwpear3nm9r">{l.figure}</span>
                <span className="text-[11px] text-graphite" data-id="element-75" data-mp="26rtctwb9wak">{l.caption}</span>
              </p>
              <h4 className="mt-2 text-[14.5px] font-semibold leading-snug text-ink" data-id="element-76" data-mp="741tp4l8nsd6">{l.title}</h4>
              <p className="mt-1 text-[12.5px] leading-relaxed text-graphite" data-id="element-77" data-mp="a3z30804dnp4">{l.body}</p>
            </li>)}
        </ul>
      </section>

      <section aria-labelledby="next-title" className="rounded-2xl bg-navy p-5 text-white" data-id="element-78" data-mp="jv3ir9xmdcl0">
        <h3 id="next-title" className="text-[12px] font-medium text-white/70" data-id="element-79" data-mp="jwwfnxifkift">
          Proposed next action
        </h3>
        <p className="mt-2 flex items-start gap-2 text-[17px] font-semibold leading-snug" data-id="element-80" data-mp="3nbaaqj6o9ldy">
          <ArrowRightIcon size={18} strokeWidth={2} className="mt-0.5 shrink-0 text-teal-soft" aria-hidden="true" data-id="element-81" data-mp="3icz2udzxtkyd" />
          {NEXT_ACTION.title}
        </p>
        <p className="mt-1 pl-[26px] text-[12.5px] text-white/70" data-id="element-82" data-mp="8falvkrl754">{NEXT_ACTION.basis}</p>
      </section>
    </div>;
}